export type ClosingMessageLanguage = "fi" | "en";

export type CloseConversationOptions = {
  sendClosingMessage: boolean;
  language: ClosingMessageLanguage;
};

export const DEFAULT_CLOSE_CONVERSATION_OPTIONS: CloseConversationOptions = {
  sendClosingMessage: true,
  language: "fi",
};

export const CONVERSATION_CLOSING_MESSAGES: Record<
  ClosingMessageLanguage,
  string
> = {
  fi: "Merkitsen keskustelun nyt ratkaistuksi. Mikäli sinulle tulee vielä muuta mieleen, voit avata uuden keskustelun. ☺️\n\nMukavaa päivää! ☀️",
  en: "I will mark this chat as resolved; it will be closed now. If you have any further questions, feel free to start a new chat. 😊\n\nHave a nice day! ☀️",
};

export const getConversationClosingMessage = (
  language: ClosingMessageLanguage,
): string =>
  CONVERSATION_CLOSING_MESSAGES[language] ?? CONVERSATION_CLOSING_MESSAGES.fi;

export const getClosingMessageToSend = ({
  sendClosingMessage,
  language,
}: CloseConversationOptions): string | null => {
  if (!sendClosingMessage) return null;
  return getConversationClosingMessage(language);
};
